import { IconButton } from '@fullscreendigital/carrefour-dex-fe'
import { PrintOutlined } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

const PrintButton = ({ onClick }) => {
  return (
    <Box
      sx={{
        padding: { xs: '4px 12px', sm: '4px 16px' },
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        borderRadius: { xs: '24px', sm: '24px' },
        border: { xs: '1px solid #0970E6', sm: '1px solid #0970E6' },
        fontSize: '14px'
      }}
    >
      <IconButton
        sx={{
          padding: '0px',
          color: '#0970E6',
          borderRadius: 'none',
          '&:hover': {
            backgroundColor: 'white'
          }
        }}
        size="small"
        onClick={onClick}
      >
        <Box sx={{ display: { xs: 'none', sm: 'inherit' } }}>
          <Typography
            sx={{
              fontSize: '14px',
              marginRight: '8px'
            }}
            variant="medium"
          >
            Print
          </Typography>
        </Box>
        <PrintOutlined />
      </IconButton>
    </Box>
  )
}

export default PrintButton
